<!-- MODAL HEADER-->
<div class="row modal-bar">
  <div class="col-sm-9">
    <h5 class="modal-title">{{ passedData.title | translate }}</h5>
  </div>
  <div class="col-sm-3">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="form" class="form-content">
  <div class="section-wrapper">
    <div class="form-layout">

      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <label class="form-control-label">{{'LOCATIONS.FILTER-GROUPS.DIALOG.FORM.LABEL.CODE' | translate}} <span class="tx-danger">*</span></label>
            <input class="form-control" name="code" formControlName="Code" placeholder="{{'LOCATIONS.FILTER-GROUPS.DIALOG.FORM.PLACEHOLDER.CODE' | translate}}">
            {{ 'LOCATIONS.FILTER-GROUPS.DIALOG.FORM.TRANSLATION-CODE' | translate: { code: getGroupTranslationCode() } }}
            <t4-display-validation controlName="Code" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-control-label">{{'LOCATIONS.FILTER-GROUPS.DIALOG.FORM.LABEL.FRIENDLY-NAME' | translate}} <span class="tx-danger">*</span></label>
            <input class="form-control" name="friendlyName" formControlName="FriendlyName" placeholder="{{'LOCATIONS.FILTER-GROUPS.DIALOG.FORM.PLACEHOLDER.FRIENDLY-NAME' | translate}}">
            <t4-display-validation controlName="FriendlyName" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-control-label">{{'LOCATIONS.FILTER-GROUPS.DIALOG.FORM.LABEL.DISPLAY-ORDINAL-NUMBER' | translate}} <span class="tx-danger">*</span></label>
            <input class="form-control" name="displayOrdinalNumber" formControlName="DisplayOrdinalNumber" placeholder="{{'LOCATIONS.FILTER-GROUPS.DIALOG.FORM.PLACEHOLDER.DISPLAY-ORDINAL-NUMBER' | translate}}">
            <t4-display-validation controlName="DisplayOrdinalNumber" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>
      </div>

      <div class="row">
        <t4-list-view #criteriaListVw [options]="criteriaListOptions" (onDataRequest)="onCriteriaDataRequest($event)" class="w-100">

          <ng-container *t4ListActions>
            <button (click)="addCriterion()" class="btn btn-primary border" type="button"><i class="far fa-plus-square"></i>{{ 'LOCATIONS.FILTER-GROUPS.DIALOG.CRITERIA-LISTVIEW.ADD' | translate }}</button>
          </ng-container>

          <ng-container *t4ListItem="let item" [formGroupName]="getCriterionFormGroupName(item)">

            @if (showIdColumn) {
              <th scope="row" style="width: 60px; vertical-align: middle;">{{ item.Id > 0 ? "#" + item.Id : "" }}</th>
            }
            <td>
              <input class="form-control" [class.invalid]="isCodeInvalid(item)" name="code" formControlName="Code" placeholder="{{'LOCATIONS.FILTER-GROUPS.DIALOG.CRITERIA-LISTVIEW.PLACEHOLDER.CODE' | translate}}">
            </td>
            <td>
              <input class="form-control" [class.invalid]="isDisplayOrdinalNumberInvalid(item)" name="displayOrdinalNumber" formControlName="DisplayOrdinalNumber" placeholder="{{'LOCATIONS.FILTER-GROUPS.DIALOG.CRITERIA-LISTVIEW.PLACEHOLDER.DISPLAY-ORDINAL-NUMBER' | translate}}">
            </td>
            <td>
              <input class="form-control" [class.invalid]="isFriendlyNameInvalid(item)" name="friendlyName" formControlName="FriendlyName" placeholder="{{'LOCATIONS.FILTER-GROUPS.DIALOG.CRITERIA-LISTVIEW.PLACEHOLDER.FRIENDLY-NAME' | translate}}">
            </td>

            <td class="grid-action">
              <button (click)="this.tryDeleteCriterion(item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
            </td>

          </ng-container>

        </t4-list-view>
      </div>

      <div class="form-layout-footer row">
        <div class="col-6">
          <button (click)="submit()" [disabled]="!form || !form.dirty || !form.valid || saving" class="btn btn-block btn-primary bd-0">
            <i class="far fa-save"></i><span>{{ 'GENERIC.BUTTON.SAVE' | translate }}</span>
          </button>
        </div>
        <div class="col-6">
          <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0">
            <i class="fas fa-ban"></i><span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</form>
